/** On-demand translation of a German content block. The backend caches every
 *  block globally; we add a tiny session-level memo so re-tapping the same text
 *  is instant and never re-hits the network. */
import { request } from "./http";

const memo = new Map<string, string>();

export async function translateText(text: string, targetLang = "en"): Promise<string> {
  const key = `${targetLang}:${text}`;
  const hit = memo.get(key);
  if (hit !== undefined) return hit;
  const res = await request<{ translation: string }>("/translate/", {
    method: "POST",
    body: { text, target_lang: targetLang },
  });
  memo.set(key, res.translation);
  return res.translation;
}
